/** Do not edit this file, it is automatically generated **/
import React, { PropsWithChildren } from "react";
import styled from "styled-components";

import Icon, { IconProps } from "./Icon";

const IconRedirectLineComponent: React.FC<PropsWithChildren<IconProps>> & { DataUrl: string; Content: string; } = (props) => {
return (
  <Icon {...props} viewBox="0 0 16 16">
    <path d="M12.2,3h-6C5.7,3,5.4,3.4,5.4,3.8s0.4,0.8,0.8,0.8h3.9l-6.9,6.9c-0.3,0.3-0.3,0.9,0,1.2c0,0,0,0,0,0c0.3,0.3,0.9,0.3,1.2,0 c0,0,0,0,0,0l6.9-6.9v3.9c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8V3.8C13,3.4,12.6,3,12.2,3L12.2,3z" />
  </Icon>
);
};

IconRedirectLineComponent.DataUrl = "data:image/svg+xml;charset=utf-8;base64,PHN2ZyB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDE2IDE2IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxwYXRoIGQ9Ik0xMi4yLDNoLTZDNS43LDMsNS40LDMuNCw1LjQsMy44czAuNCwwLjgsMC44LDAuOGgzLjlsLTYuOSw2LjljLTAuMywwLjMtMC4zLDAuOSwwLDEuMmMwLDAsMCwwLDAsMGMwLjMsMC4zLDAuOSwwLjMsMS4yLDAgYzAsMCwwLDAsMCwwbDYuOS02Ljl2My45YzAsMC41LDAuNCwwLjgsMC44LDAuOGMwLjUsMCwwLjgtMC40LDAuOC0wLjhWMy44QzEzLDMuNCwxMi42LDMsMTIuMiwzTDEyLjIsM3oiLz4KPC9zdmc+";
IconRedirectLineComponent.Content = `<svg x="0px" y="0px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
  <path d="M12.2,3h-6C5.7,3,5.4,3.4,5.4,3.8s0.4,0.8,0.8,0.8h3.9l-6.9,6.9c-0.3,0.3-0.3,0.9,0,1.2c0,0,0,0,0,0c0.3,0.3,0.9,0.3,1.2,0 c0,0,0,0,0,0l6.9-6.9v3.9c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8V3.8C13,3.4,12.6,3,12.2,3L12.2,3z"/>
</svg>`;

const IconRedirectLine = styled(IconRedirectLineComponent)``;

export default IconRedirectLine;
